import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AcmicService, HeaderComponent, MapfreCardComponent, MapfreLoadingComponent } from '@mapfre-design-library/src/public_api';
import { BillingNewService } from '@services/common/billing-new.service';
import { ErrorRedirectionService } from '@services/error-service/error-redirection.service';
import { tap, catchError } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { CommonModule } from '@angular/common';

declare let OneInc: any;

@Component({
  selector: 'app-register-payment-widget',
  templateUrl: './register-payment-widget.component.html',
  styleUrls: ['./register-payment-widget.component.scss'],
  imports: [MapfreLoadingComponent, CommonModule, MapfreCardComponent, HeaderComponent, MapfreLoadingComponent]
})
export class RegisterPaymentWidgetComponent implements OnInit, OnDestroy {
  isAcmic = false;
  loading = true;
  container: any;
  portalOne: any;
  paymentPayload: any;

  constructor(
    private router: Router,
    private acmicService: AcmicService,
    private billingNewService: BillingNewService,
    private errorRedirectionService: ErrorRedirectionService
  ) {}

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();

    const state = history.state as {
      policyNumber?: string;
      policyState?: string;
    };

    if (!state?.policyNumber) {
      this.router.navigate(['/save-payment']);
      return;
    }

    this.paymentPayload = {
      operation: 'savePaymentMethod',
      referenceNumber: state.policyNumber,
      clientReferenceData1: state.policyNumber,
      clientReferenceData5: state.policyState,
    };

    this.container = document.getElementById('portalOneContainer');
    this.portalOne = new OneInc.PortalOne(
      this.container,
      this.subscribeToEvents(this.container)
    );

    this.billingNewService.getOneIncTokensForGuest(this.paymentPayload).pipe(
      tap(res => {
        if (!res?.PortalOneSessionKey || !res?.Token) {
          throw new Error('Missing session or token in response');
        }
      }),
      catchError(err => {
        if (err.status === 503 && err.error?.Code === '965') {
          this.router.navigate(['/service', 'message'], {
            state: { errInfo: { ...err.error, hideContactSection: true } },
          });
        } else {
          this.errorRedirectionService.errorRedirectHandler(err);
        }
        return EMPTY;
      })
    ).subscribe(res => {
      this.loading = false;
      this.portalOne.run({
        sessionId: res.PortalOneSessionKey,
        accessTokenId: res.Token,
        displayMode: 'Inline',
        allowClosing: true,
        loadingIndication: false,
      });
    });
  }

  subscribeToEvents(container: HTMLElement) {
    if (!container) {
      return;
    }

    container.addEventListener('portalOne.load', (data: any) => {
      this.loading = false;
      const payload = JSON.stringify({
        saveCardLoaded:   'Success',
        returnValue:      data?.returnValue,
        policyNumber:     this.paymentPayload?.clientReferenceData1,
      });
      this.billingNewService.postPaymentEventGuest(payload).subscribe();
    });

    
    container.addEventListener('portalOne.saveComplete', (data: any) => {
      const payload = JSON.stringify({
        saveCardStatus:    'Success',
        tokenId:          data.detail?.tokenId,
        cardType:         data.detail?.cardType,
        paymentCategory:  data.detail?.paymentCategory,
        policyNumber:     this.paymentPayload?.clientReferenceData1,
      });
      this.billingNewService.postPaymentEventGuest(payload).subscribe();
    });
    container.addEventListener('portalOne.error', (err: any) => {
      const payload = JSON.stringify({
        saveCardStatus: 'Failed',
        errorCode:     err.detail?.errorCode,
        errorMessage:  err.detail?.Description ?? err.detail?.errorMessage,
        policyNumber:  this.paymentPayload?.clientReferenceData1,
      });
      this.billingNewService.postPaymentEventGuest(payload).subscribe();
    });
    container.addEventListener('portalOne.unload', () => {
      this.router.navigate(['/save-payment']);
    });
  }

  ngOnDestroy() {
    if (this.container) {
      const newContainer = this.container.cloneNode(true) as HTMLElement;
      this.container.replaceWith(newContainer);
      this.container = null;
    }
  }
}
